export const getStringDate = (date) => {
  if (date) {
    let current_datetime = new Date(new Date(date).toGMTString());
    var hours = current_datetime.getHours();
    var minutes = current_datetime.getMinutes();
    var month = current_datetime.getMonth() + 1;
    var day = current_datetime.getDate();
    var seconds = current_datetime.getSeconds();

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    var tzAbbr = "";
    var dateObject = new Date(),
      dateString = dateObject + "",
      tzAbbr =
        dateString.match(/\(([^\)]+)\)$/) ||
        dateString.match(/([A-Z]+) [\d]{4}$/);
    if (tzAbbr) {
      tzAbbr = tzAbbr[1].match(/[A-Z]/g).join("");
      if (tzAbbr === "CUT") {
        tzAbbr = "UTC";
      }
    }
    return (
      current_datetime.getFullYear() +
      "-" +
      month +
      "-" +
      day +
      "  " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      tzAbbr
    );
  } else {
    return " ";
  }
};

export const priceDisplay = (price, userCurrency = "$", issign = false) => {
  if (price === "-" || price === "") {
    return price;
  }
  if (Number(price) === 0) {
    return userCurrency + "0.00";
  }
  var sign = "";
  if (issign) {
    sign = "-";
  }

  if (String(Number(price)).indexOf(".") !== -1) {
    return `${userCurrency}${sign}${Number(price).toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })}`;
  }
  return `${userCurrency}${sign}${Number(price).toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })}`;
};

export const getStringDateAnalysis = (date, userGmtId, userTimeZoneName) => {
  if (date) {
    let current_datetime = new Date(new Date(date).toGMTString());
    var hours = current_datetime.getHours();
    var minutes = current_datetime.getMinutes();
    var month = current_datetime.getMonth() + 1;
    var day = current_datetime.getDate();
    var seconds = current_datetime.getSeconds();

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    var tzAbbr = "";

    if (userGmtId) {
      tzAbbr = userGmtId;
      if (tzAbbr === "CUT") {
        tzAbbr = "UTC";
      }
    } else {
      var dateObject = new Date(),
        dateString = dateObject + "",
        tzAbbr =
          dateString.match(/\(([^\)]+)\)$/) ||
          dateString.match(/([A-Z]+) [\d]{4}$/);
      if (tzAbbr) {
        tzAbbr = tzAbbr[1].match(/[A-Z]/g).join("");
        if (tzAbbr === "CUT") {
          tzAbbr = "UTC";
        }
      }
    }

    return (
      current_datetime.getFullYear() +
      "-" +
      month +
      "-" +
      day +
      "  " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      tzAbbr
    );
  } else {
    return " ";
  }
};

// export const priceDisplay = (price, userCurrency = "$", issign = false) => {
//   if (price === "-" || price === "") {
//     return price;
//   }

//   if (userCurrency === "INR") {
//     userCurrency = "₹";
//   } else if (userCurrency === "EUR") {
//     userCurrency = "€";
//   } else if (userCurrency === "GBP") {
//     userCurrency = "£";
//   } else if (userCurrency === "CAD") {
//     userCurrency = "C$";
//   } else if (userCurrency === "USD") {
//     userCurrency = "$";
//   }

//   if (Number(price) === 0) {
//     return userCurrency + "0.00";
//   }
//   var sign = "";
//   if (issign) {
//     sign = "-";
//   }

//   if (String(Number(price)).indexOf(".") !== -1) {
//     return `${userCurrency}${sign}${Number(price).toLocaleString("en-US", {
//       maximumFractionDigits: 2,
//       minimumFractionDigits: 2,
//     })}`;
//   }
//   return `${userCurrency}${sign}${Number(price).toLocaleString("en-US", {
//     maximumFractionDigits: 2,
//     minimumFractionDigits: 2,
//   })}`;
// };

export const getNumericValue = (value) => {
  if (typeof value !== "string") {
    return value;
  }
  const match = value.match(/-?\$\d+(?:\.\d+)?/);
  const amount = match ? parseFloat(match[0].replace("$", "")) : null;
  return amount;
};

export const priceDisplayTotal = (
  price,
  userCurrency = "$",
  issign = false
) => {
  if (price === "-" || price === "") {
    return price;
  }
  if (Number(price) === 0) {
    return userCurrency + "0.00";
  }

  const numericPrice = `${
    price < 0 ? "-" : issign ? "+" : ""
  }${userCurrency}${Math.abs(price).toFixed(2)}`;
  return numericPrice;
};

// api.js

export async function apiFetch(url, options = {}) {
  const response = await fetch(url, options);

  if (!response.ok) {
    const message = await response.text();

    throw new Error(
      message || `HTTP ${response.status}`
    );
  }

  return response.json();
}